import {TOGGLE_QUESTION_FLAGGED, SAVE_ANSWER, CLEAR_RESPONSE, SAVE_ANSWER_NOTE} from '../actions/response';
import { LOAD_RESPONSE_DATA } from '../actions/response';

const answers = (state = {}, action) => {
  switch(action.type) {
    case TOGGLE_QUESTION_FLAGGED:
      var answer = state[action.id] || {};
      return {
        ...state,
        [action.id]: {
          ...answer,
          flagged: !answer.flagged,
          answeredInSection: action.section || answer.section
        }
      }
    case SAVE_ANSWER:
      var answer = state[action.question] || {};
      return {
        ...state,
        [action.question]: {
          ...answer,
          value: action.answer,
          answeredInSection: action.section
        }
      }
    case SAVE_ANSWER_NOTE:
      var answer = state[action.question] || {};
      return {
        ...state,
        [action.question]: {
          ...answer,
          note: action.note
        }
      }
    case CLEAR_RESPONSE:
      return {};
    case LOAD_RESPONSE_DATA:
      return {
        ...action.payload.answers
      }
    default:
      return state;
  }
}

export default answers;

// export const getNextSectionAndQuestionIndex = (answers) => {
//   let sections = ["monitoring", "assessment", "controlRules"];
//   let result = {
//     section: "monitoring",
//     answer: 0
//   }
//   let numAnswers = Object.keys(answers).reduce((list, questionID) => {
//     let answer = answers[questionID];
//     list[answer.answeredInSection || "monitoring"] += 1;
//     return list;
//   }, sections.reduce((obj, section) => {
//     obj[section] = 0;
//     return obj;
//   }, {}));
//   for (let section of sections.reverse()) {
//     if (numAnswers[section] > 0) {
//       result.section = section;
//       result.questionIndex = numAnswers[section];
//       break;
//     }
//   }
//
//   return result;
//
// }
